import React from 'react';
import AdvisioAddin from './components/AdvisioAddin';
import { AuthProvider } from './context/AuthContext';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="h-screen">
        <AdvisioAddin />
      </div>
    </AuthProvider>
  );
};

export default App;
